// extracted by mini-css-extract-plugin
module.exports = {"illustrationContainer":"auth-page_illustrationContainer__6M5F3","authPage":"auth-page_authPage__W5m9Z"};